import React from 'react';
import { withRouter } from 'react-router-dom';

import './index.css';

const Article = ({ image, title, description, history }) => (
  <div className="articlePreview" onClick={() => history.push(`/blog/${title.toLowerCase()}`)}>
    <div className="articlePreview__image">
      <img src={image} alt="article preview" />
    </div>
    <h3 className="articlePreview__title">{title}</h3>
    <div className="articlePreview__filters">{localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}</div>
    <p className="articlePreview__description">{localStorage.getItem('lang') == 'ru'? description[0]:description[1]}</p>
  </div>
)

export default withRouter(Article);


// WEBPACK FOOTER //
// ./src/components/articlePreview/index.jsx